import { z } from 'zod';

export const fieldFilter = z.object({
    fieldType: z.enum(['string', 'color']),
    color: z.string().optional(),
    fieldName: z.string(),
    fieldValue: z.string(),
    fieldTranslatedName: z.string().optional(),
    fieldTranslatedValue: z.string().optional(),
    isFeaturedFilterInUI: z.boolean().optional(),
    isSuggestedFilterInUI: z.boolean().optional()
});

export type FieldFilter = z.infer<typeof fieldFilter>;
